<template>
  <div class="sceneVideo" :data-blur="hasOverlay">
    <div class="sceneVideo__player"></div>
    <div class="sceneVideo__interface" v-if="hasVideoLoaded">
      <div class="sceneVideo__close">
        <img :src="returnPath('assets/img/svg/close.svg')" alt="" @click.prevent="goBack"/>
      </div>
    </div>
    <transition name="slideOverlay">
      <div class="sceneVideo__overlay" v-show="hasOverlay" @click="disableOverlay">
        <div class="sceneVideo__overlay__content">
          <div class="sceneVideo__overlay__item" @click.stop="goToInteractive">
            <div class="sceneVideo__overlay__item__box">
              <icon-interactive></icon-interactive>
              <img :src="returnPath('assets/img/icons/interactive.gif')" alt=""/>
            </div>
            <div class="sceneVideo__overlay__item__caption">
              <p>{{interactiveLabel}}</p>
            </div>
          </div>
          <div class="sceneVideo__overlay__item" @click.stop="goBack">
            <div class="sceneVideo__overlay__item__box">
              <icon-back></icon-back>
            </div>
            <div class="sceneVideo__overlay__item__caption">
              <p>{{backLabel}}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  var Player;
  var url;
  import Interactive from './icons/Interactive';
  import Back from './icons/Back';

  export default{
    data(){
      return {
        backLabel: '',
        interactiveLabel: '',
        jwPlayerLoaded: false,
        hasOverlay: false,
        hasVideoLoaded: false,
        isPlayerReady: false,
        videoTitle: ''
      }
    },
    components: {
      'icon-interactive': Interactive,
      'icon-back': Back
    },
    mounted(){
      var vm = this;
      vm.hideUI();
      vm.loadListing();
      vm.$forceUpdate();
    },
    updated() {
      var vm = this;
      vm.hideUI();
    },
    created(){
      var vm = this;
      vm.hideUI();
      vm.backLabel = vm.$store.state.labels.videoMode.popupBack;
      vm.interactiveLabel = vm.$store.state.labels.videoMode.popupInteractive;
    },
    methods: {
      //Function to hide app interface/footer
      hideUI(){
        var vm = this;
        vm.$store.state.hasApplicationLoaded = true;
        vm.$store.state.interface.isVisible = true;
        vm.$store.state.interface.isFooterVisible = false;
        vm.$store.state.interface.breadcrumbsOnly = true;
      },

      //Function to load scene listing
      loadListing(){
        var vm = this;
        if (jwplayer) {
          Player = jwplayer(document.querySelector('.sceneVideo__player'));
          url = document.querySelector('#root').getAttribute('data-endpoint-listing');
          var videoID = vm.$route.params.scenedetail;
//          console.log(videoID);
          var sceneListing = vm.$store.state.sceneListing;
          if (sceneListing.length) {
            vm.initPlayer(vm.retrieveVideo(sceneListing, videoID)[0]);
          }
          else {
            fetch(url)
              .then(function (response) {
                return response.json();
              })
              .catch(function () {
                that.$router.push('/');
              })
              .then(function (data) {
                if (data.header.success) {
                  sceneListing = data.data;
                  vm.initPlayer(vm.retrieveVideo(sceneListing, videoID)[0]);
                }
                else {
                  that.$router.push('/');
                }
              })
          }
        }
      },

      //Function to return single video
      retrieveVideo(listing, videoID){
        return listing.filter(function (obj) {
          return obj.slag == videoID;
        });
      },

      //Function to init video player
      initPlayer(video){
        var vm = this;
        if (video) {
          eventTracking.send({
            category: 'Guided',
            action: 'View',
            label: video.slag
          });

          var playerSettings = {
            file: video.video.source.file,
            //width: "100%",
            //height: "100%",
            //stretching: 'fill',
            aspectratio: '16:9',
            stretching: "uniform",
            skin: {
              name: 'custom'
            },
            tracks: video.tracks,
            autostart: false,
            controls: true,
            ga: {
              label: video.title
            }
          };

          vm.videoTitle = video.title;
          video = video.video;
          Player.setup(playerSettings);

          //Start building video widget
          Player.on('beforePlay', function () {
            overrideControls();
            overrideSubtitleButton();
            buildSubtitleBox();
            buildNextVideoButton();
          });

          vm.$nextTick()
            .then(function () {
              vm.isPlayerReady = true;
              vm.hasVideoLoaded = true;
              //Try reloading video if error
              Player.on('error', function (err) {
                Player.load({
                  file: video.source.file,
                  tracks: video.tracks
                })
              });
              //Play video after 1s if not already started
              Player.on('ready', function () {
                setTimeout(function () {
                  Player.play();
                }, 1000);
              });
              //Open overlay when video finishes
              Player.on('playlistComplete', function () {
                vm.hasOverlay = true;
              });
            });
        }
        else {
          vm.$router.push('/');
        }

        //Change disposition of standard video player UI
        function overrideControls() {
          var sliderTime = document.querySelector('.jw-slider-time');
          var volumeBtn = document.querySelector('.jw-icon-volume');
          volumeBtn.parentNode.insertBefore(sliderTime, volumeBtn.nextSibling);
        }

        //Change icon SVG of Closed Captions button
        function overrideSubtitleButton() {
          var ccBtn = document.querySelector('.jw-icon-cc');
          ccBtn.innerHTML = '';
          var textBox = document.createElement('div');
          vm.addClass(textBox, 'jw-reset');
          vm.addClass(textBox, 'jw-tooltip-captions');
          vm.addClass(textBox, 'jw-tooltip');
          vm.addClass(textBox, 'jw-open');
          var textContent = document.createElement('div');
          vm.addClass(textContent, 'jw-text');
          textContent.textContent = '';
          textBox.appendChild(textContent);
          var svgOff = '<svg class="jw-svg-icon jw-svg-icon-cc-off" width="43px" height="33px" viewBox="0 0 43 33" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="04_02_VIRTUAL" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1295.000000, -966.000000)"><g id="Group" transform="translate(47.000000, 967.000000)" stroke="#FFFFFF" stroke-width="2"><g id="Player"><g id="Language" transform="translate(1249.000000, 0.000000)"><polygon id="Path-3" points="10.3129494 30 10.3129494 22.2365944 0 22.2365944 8.89045781e-18 3.55271368e-15 41 3.55271368e-15 41 22.2365944 34.6103563 22.2365944 22.2355474 22.2365944"></polygon><path d="M7,9 L35,9" id="Path-5-Copy"></path><path d="M7,14 L35,14" id="Path-5"></path></g></g></g></g></svg>';
          var svgOn = '<svg class="jw-svg-icon jw-svg-icon-cc-on" width="43px" height="33px" viewBox="0 0 43 33" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="04_02_VIRTUAL" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1295.000000, -966.000000)"><g id="Group" transform="translate(47.000000, 967.000000)" stroke="#FFFFFF" stroke-width="2"><g id="Player"><g id="Language" transform="translate(1249.000000, 0.000000)"><polygon id="Path-3" points="10.3129494 30 10.3129494 22.2365944 0 22.2365944 8.89045781e-18 3.55271368e-15 41 3.55271368e-15 41 22.2365944 34.6103563 22.2365944 22.2355474 22.2365944"></polygon><path d="M7,9 L35,9" id="Path-5-Copy"></path><path d="M7,14 L35,14" id="Path-5"></path></g></g></g></g></svg>';
          ccBtn.innerHTML = svgOff + svgOn;
          ccBtn.appendChild(textBox);
        }

        //Build custom CC box
        function buildSubtitleBox() {
          Player.addButton(ENV.assetsRoot + 'assets/img/svg/language.svg', '', language, 'language');
          vm.changeDefaultButtonClass('div[button="language"]', 'jw-language');
          var jwPanel_language = document.createElement('div');
          vm.addClass(jwPanel_language, 'jw-panel-language');

          vm.addClass(document.querySelector('.jw-tooltip-captions'), 'jw-open');

          var textBox = document.createElement('div');
          vm.addClass(textBox, 'jw-reset');
          vm.addClass(textBox, 'jw-tooltip-fake');
          vm.addClass(textBox, 'jw-tooltip');
          vm.addClass(textBox, 'jw-open');
          var textContent = document.createElement('div');
          vm.addClass(textContent, 'jw-text');
          textBox.appendChild(textContent);
          jwPanel_language.appendChild(textBox);

          var languageBtn = document.querySelector('.jw-language');
          languageBtn.appendChild(jwPanel_language);
          vm.buildSubtitleTooltip(video.tracks);
          languageBtn.addEventListener('focusout', function () {
            if (languageBtn.classList.contains('is-open')) {
              vm.toggleClass(languageBtn, 'is-open');
            }
          });

          function language() {
            var jwLanguageBtn = document.querySelector('.jw-language');
            var target = jwLanguageBtn.querySelector('.jw-button-image');
            var className = 'is-open';

            vm.toggleClass(jwLanguageBtn, className);

            if (vm.hasClass(jwLanguageBtn, className)) {
              target.style.backgroundImage = 'url("' + ENV.assetsRoot + 'assets/img/svg/captions-red.svg' + '")';
            }
            else {
              target.style.backgroundImage = 'url("' + ENV.assetsRoot + 'assets/img/svg/language.svg' + '")';
            }

            var siblings = Array.prototype.filter.call(jwLanguageBtn.parentNode.children, function (child) {
              return child !== jwLanguageBtn;
            });

            for (var i = 0; i < siblings.length; i++) {
              (function () {
                vm.removeClass(siblings[i], className);
              })()
            }
          }
        }

        //Function to build custom next video button
        function buildNextVideoButton() {
          Player.addButton(ENV.assetsRoot + 'assets/img/svg/skip.svg', '', next, 'next');
          vm.changeDefaultButtonClass('div[button="next"]', 'jw-next-video');

          function next() {
            vm.goToNextVideo();
          }
        }
      },


      //Function to build custom audio tool
      buildVideoLanguageTooltip(srcFile){

        //Add data to language panel
        var jwPanel_language = document.querySelector('.jw-panel-language');
        var jwPanel_languageWrapperAudio = document.createElement('div');
        jwPanel_languageWrapperAudio.className = 'jw-panel-language__wrapper jw-panel-language__wrapper--audio';

        var jwPanel__languageTitle = document.createElement('span'),
          jwPanel__languageList = document.createElement('ul');

        jwPanel__languageTitle.className = 'jw-panel-language__title';
        jwPanel__languageList.className = 'jw-panel-language__list jw-panel-language__list--audio';
        jwPanel__languageTitle.innerText = 'Audio';

        jwPanel_languageWrapperAudio.appendChild(jwPanel__languageTitle);
        jwPanel_languageWrapperAudio.appendChild(jwPanel__languageList);


        for (var i = 0; i < srcFile.length; i++) {
          (function(){
            var value = srcFile[i];
            var jwPanel__languageList__item = document.createElement('li');
            var jwPanel__languageList__itemLink = document.createElement('a');
            if (value.default === true) jwPanel__languageList__itemLink.className = 'is-active';

            jwPanel__languageList__itemLink.setAttribute('href', value.file);
            jwPanel__languageList__itemLink.innerText = value.label;

            jwPanel__languageList__item.appendChild(jwPanel__languageList__itemLink);

            jwPanel__languageList__item.className = 'jw-panel-language__list__item';
            jwPanel__languageList.appendChild(jwPanel__languageList__item);
          })()
        }

        jwPanel_language.appendChild(jwPanel_languageWrapperAudio);

        var $captionList = Player.getCaptionsList();

        var jwPanel__language__listItems = jwPanel_languageWrapperAudio.querySelectorAll('a');
        for (var i = 0; i < jwPanel__language__listItems.length; i++) {
          (function(){
            var elem = jwPanel__language__listItems[i];

            elem.addEventListener('click', function (event) {
              event.preventDefault();
              if (elem.classList) {
                if (elem.classList.contains('is-active')) {
                  return;
                }
                var elemParent = elem.parentNode;
                var elemParentSiblings = Array.prototype.filter.call(elemParent.parentNode.children, function (child) {
                  return child !== elemParent;
                });
                for (var i = 0; i < elemParentSiblings.length; i++) {
                  var elemChildren = elemParentSiblings[i].children;
                  for (var j = 0; j < elemChildren.length; j++) {
                    var that = elemChildren[j];
                    vm.removeClass(that, 'is-active');
                  }
                }
                vm.addClass(elem, 'is-active');
              }

              var jwPanel__languageList__subTitle__Items = document.querySelectorAll('.jw-panel-language__list--subtitle  > .jw-panel-language__list__item > a');
              for (var k = 0; k < jwPanel__languageList__subTitle__Items.length; k++) {
                var thatItem = jwPanel__languageList__subTitle__Items[k];
                vm.removeClass(thatItem, 'is-active');
              }
              var $currentPosition = Player.getPosition();
              var $fileSource = elem.getAttribute('href');
              var $currentCaption = Player.getCurrentCaptions();
              //console.info($currentCaption);
              //Load file video
              Player.load({file: $fileSource, tracks: $captionList});
              Player.play(true);

              //After loading set seek to current position (switch language)
              Player.on('play', function () {
                Player.seek($currentPosition);
                Player.setCurrentCaptions($currentCaption);
              });
            });
            elem.addEventListener('touchstart', function (event) {
              event.preventDefault();
              if (elem.classList) {
                if (elem.classList.contains('is-active')) {
                  return;
                }
                var elemParent = elem.parentNode;
                var elemParentSiblings = Array.prototype.filter.call(elemParent.parentNode.children, function (child) {
                  return child !== elemParent;
                });
                for (var i = 0; i < elemParentSiblings.length; i++) {
                  var elemChildren = elemParentSiblings[i].children;
                  for (var j = 0; j < elemChildren.length; j++) {
                    var currentElement = elemChildren[j];
                    vm.removeClass(currentElement, 'is-active');
                  }
                }
                vm.addClass(elem, 'is-active');
              }

              var jwPanel__languageList__subTitle__Items = document.querySelectorAll('.jw-panel-language__list--subtitle  > .jw-panel-language__list__item > a');
              for (var k = 0; k < jwPanel__languageList__subTitle__Items.length; k++) {
                var thatItem = jwPanel__languageList__subTitle__Items[k];
                vm.removeClass(thatItem, 'is-active');
              }
              var $currentPosition = Player.getPosition();
              var $fileSource = elem.getAttribute('href');
              var $currentCaption = Player.getCurrentCaptions();
              //Load file video
              Player.load({file: $fileSource, tracks: $captionList});
              Player.play(true);
              //After loading set seek to current position (switch language)
              Player.on('play', function () {
                Player.seek($currentPosition);
                Player.setCurrentCaptions($currentCaption);
              });
            })
          })()
        }
      },

      //Function to build custom CC tool
      buildSubtitleTooltip(tracks){

        var vm = this;

        //Add data to language panel
        var jwPanel_language = document.querySelector('.jw-panel-language');
        var jwPanel_languageWrapper = document.createElement('div');
        jwPanel_languageWrapper.className = 'jw-panel-language__wrapper jw-panel-language__wrapper--subtitle';

        jwPanel_language.appendChild(jwPanel_languageWrapper);

        var jwPanel__languageSubtitles = document.querySelector('.jw-panel-language > .jw-panel-language__wrapper--subtitle');
        var jwPanel__languageSubtitles__list = document.createElement('ul');
        var jwPanel__languageSubtitles__title = document.createElement('span');
        jwPanel__languageSubtitles__title.className = 'jw-panel-language__title';
        jwPanel__languageSubtitles__list.className = 'jw-panel-language__list jw-panel-language__list--subtitle';

        jwPanel__languageSubtitles__title.innerText = 'Sub';

        jwPanel__languageSubtitles.appendChild(jwPanel__languageSubtitles__title);
        jwPanel__languageSubtitles.appendChild(jwPanel__languageSubtitles__list);

        for (var i = 0; i < tracks.length; i++) {
          (function(){
            var value = tracks[i];
            var jwPanel__languageSubtitles__listItem = document.createElement('li');
            jwPanel__languageSubtitles__listItem.className = 'jw-panel-language__list__item';
            var jwPanel__languageSubtitles__listItem__link = document.createElement('a');
            jwPanel__languageSubtitles__listItem__link.setAttribute('href', i);
            jwPanel__languageSubtitles__listItem__link.innerText = value.label;

            jwPanel__languageSubtitles__listItem.appendChild(jwPanel__languageSubtitles__listItem__link);
            jwPanel__languageSubtitles__list.appendChild(jwPanel__languageSubtitles__listItem);
          })()
        }


        var currentCaptionIndex = Player.getCurrentCaptions();
        //console.warn("CURRENT CAPTIONS", currentCaptionIndex);
        var captionLinks = document.querySelectorAll('.jw-panel-language__wrapper--subtitle a');
        //console.warn("LINKS", captionLinks);
        for (var i = 0; i < captionLinks.length; i++) {
          (function(){
            var el = captionLinks[i];
            vm.removeClass(el, 'is-active');
            if (i === currentCaptionIndex - 1) {
              vm.addClass(el, 'is-active');
            }
          })()
        }

        var jwPanel__languageSubtitles__listItem__allLinks = jwPanel__languageSubtitles__list.querySelectorAll('.jw-panel-language__list__item > a');
        for (var i = 0; i < jwPanel__languageSubtitles__listItem__allLinks.length; i++) {
          (function () {

            var elem = jwPanel__languageSubtitles__listItem__allLinks[i];
            elem.addEventListener('click', function (event) {
              event.preventDefault();
              //Toggle active class
              var className = 'is-active';
              if (elem.classList) {
                elem.classList.toggle(className);
              }
              else {
                var classes = elem.className.split(' ');
                var existingIndex = classes.indexOf(className);

                if (existingIndex >= 0) {
                  classes.splice(existingIndex, 1);
                }
                else {
                  classes.push(className);
                }
                elem.className = classes.join(' ');
              }

              var elemParent = elem.parentNode;
              var elemParentSiblings = Array.prototype.filter.call(elemParent.parentNode.children, function (child) {
                return child !== elemParent;
              });
              for (var i = 0; i < elemParentSiblings.length; i++) {
                (function () {
                  var siblingChild = elemParentSiblings[i];
                  if (siblingChild.classList)
                    siblingChild.classList.remove(className);
                  else
                    siblingChild.className = siblingChild.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                })()
              }
              //If this is now the active option, get subtitles
              if (elem.classList) {
                if (elem.classList.contains(className)) {
                  var $fileSource = parseInt(elem.getAttribute('href'));
                  var $currentPosition = Player.getPosition();
                  Player.load({
                    file: Player.getPlaylistItem()['sources'][Player.getCurrentQuality()].file,
                    tracks: tracks
                  });
                  Player.play(true);
                  //After loading set seek to current position (switch subtitle)
                  Player.on('play', function () {
                    Player.seek($currentPosition);
                    Player.setCurrentCaptions($fileSource + 1); // The first is Off (0)
                  });
                  var currentCaptionIndex = $fileSource + 1;
                  var captionLinks = document.querySelectorAll('.jw-panel-language__wrapper--subtitle a');
                  for (var i = 0; i < captionLinks.length; i++) {
                    (function () {
                      var el = captionLinks[i];
                      vm.removeClass(el, 'is-active');
                      if (i === currentCaptionIndex - 1) {
                        vm.addClass(el, 'is-active');
                      }
                    })()
                  }
                }
                else {
                  new RegExp('(^| )' + className + '( |$)', 'gi').test(elem.className);
                  Player.setCurrentCaptions(0); // The first is Off (0)
                }
              }
            });

            elem.addEventListener('touchstart', function (event) {
              event.preventDefault();
              //Toggle active class
              var className = 'is-active';
              if (elem.classList) {
                elem.classList.toggle(className);
              }
              else {
                var classes = elem.className.split(' ');
                var existingIndex = classes.indexOf(className);

                if (existingIndex >= 0) {
                  classes.splice(existingIndex, 1);
                }
                else {
                  classes.push(className);
                }
                elem.className = classes.join(' ');
              }

              var elemParent = elem.parentNode;
              var elemParentSiblings = Array.prototype.filter.call(elemParent.parentNode.children, function (child) {
                return child !== elemParent;
              });
              for (var i = 0; i < elemParentSiblings.length; i++) {
                (function(){
                  var siblingChild = elemParentSiblings[i];
                  if (siblingChild.classList)
                    siblingChild.classList.remove(className);
                  else
                    siblingChild.className = siblingChild.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                })()
              }

              //If this is now the active option, get subtitles
              if (elem.classList) {
                elem.classList.contains(className);
                var $fileSource = parseInt(elem.getAttribute('href'));
                var $currentPosition = Player.getPosition();
                Player.load({
                  file: Player.getPlaylistItem()['sources'][Player.getCurrentQuality()].file,
                  tracks: tracks
                });
                Player.play(true);

                //After loading set seek to current position (switch subtitle)
                Player.on('play', function () {
                  Player.seek($currentPosition);
                  Player.setCurrentCaptions($fileSource + 1); // The first is Off (0)
                });
              }
              else {
                new RegExp('(^| )' + className + '( |$)', 'gi').test(elem.className);
                Player.setCurrentCaptions(0); // The first is Off (0)
              }
            })
          })()
        }
      },

      //Function to change default element class, if undefined
      changeDefaultButtonClass(target, newClassName){
        var btn = document.querySelector(target);
        this.removeClass(btn, 'undefined');
        this.addClass(btn, newClassName);
      },

      //Function to go to next video, if available
      goToNextVideo(){
        var listing = this.$store.state.sceneListing;
        var paramID = this.$route.params.scenedetail;
        var isNext = false;
        var newVideoID;
        var vm = this;
        if (listing) {
          for (var i = 0; i < listing.length; i++) {
            (function () {

              var elem = listing[i];
              if (isNext) {
                newVideoID = elem.sceneId;
                var newVideoSlug = elem.slag;
                isNext = false;
                var video = vm.$store.state.sceneListing.filter(function (obj) {
                  return obj.sceneId == newVideoID;
                });
                video = video[0];
                if (video.video) {
                  var _sceneId = video.sceneId;
                  vm.videoTitle = video.title;
                  video = video.video;
                  Player.load(video.source.file);

                  setTimeout(function () {

                    eventTracking.send({
                      category: 'Guided',
                      action: 'View',
                      label: _sceneId
                    });

                    Player.play();
                    var path;
                    switch (ENV.lang) {
                      case 'en':
                        path = 'guided-tour';
                        break;
                      case 'it':
                        path = 'visita-guidata';
                        break;
                      default:
                        path = 'guided-tour';
                        break;
                    }
                    vm.$router.push('/' + ENV.lang + '/' + newVideoSlug + '/' + path);
                    vm.initPlayer(vm.retrieveVideo(listing, newVideoSlug)[0]);
                  }, 1000);
                }
                else {
                  //vm.$router.push('/' + ENV.lang);
                }
              }
              if (elem.slag == paramID) {
                isNext = true;
              }
            })()
          }
        }
      },

      //Function to go back to scene listing
      goBack(){
        this.$store.state.interface.breadcrumbsOnly = false;
        this.$store.state.interface.isFooterVisible = true;
        var lang = this.$route.params.lang;
        this.$router.push('/' + lang);
      },

      //Function to switch to interactive mode
      goToInteractive(){
        this.$store.state.interface.breadcrumbsOnly = false;
        this.$store.state.interface.isFooterVisible = true;
        var sceneId = this.$route.params.scenedetail;
        var lang = this.$route.params.lang;
        this.$router.push('/' + lang + '/' + sceneId + '/interactive');
      },

      //Function to disable end-video overlay
      disableOverlay(){
        this.hasOverlay = false;
        Player.play();
      },

      //Function to return path
      returnPath(path){
        return ENV.assetsRoot + path;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SceneVideo.vue